import { currentSubscriptionUrl } from "~/services/const";
import { useUserStore } from "~/stores/userStore";
import type { Subscription } from "~/types/services";

export const useFetchMySubscription = async () => {
  const userStore = useUserStore();
  const pointStore = usePointStore();

  const { data } = await useSFetch<Subscription>(currentSubscriptionUrl);

  const getSubscriptionStatus = (subscription: Subscription) => {
    if (subscription.name === "No Subscription") {
      return "inactive";
    } else if (subscription.points === 0 || subscription.remaining_days <= 0) {
      return "expired";
    } else {
      return "active";
    }
  };

  if (data.value) {
    pointStore.updatePoints(data.value.points);
    userStore.changeSubscription(data.value);
    userStore.changeSubscriptionStatus(getSubscriptionStatus(data.value));
  } else {
    userStore.changeSubscriptionStatus("pending");
  }
};
